// extracted by mini-css-extract-plugin
export default {"containerUpload":"upload_containerUpload__STN9H","midiaImage":"upload_midiaImage__1T+ok","midiaName":"upload_midiaName__cPzSm","iconFeedbacks":"upload_iconFeedbacks__52NGT"};